import gql from 'graphql-tag';
import FieldsDepartment from "graphql/fields/FieldsDepartment";
import FieldsCompany from 'graphql/fields/FieldsCompany'

import HelperGraphql from 'utils/helper-graphql'

const fields = {
	'company_guid': 'String',
	'active': '[String]',
};

export default gql(`
	query departments( ${ HelperGraphql.createFields( fields ) } ) {
		departments( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsDepartment}
			
			company{
				${FieldsCompany}
			}
		}
	}
`);
